import {
  Component,
  Input,
  Output,
  OnInit,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import * as _ from 'lodash';
import * as utils from 'utils/utils';

import { DefaultModalComponent } from 'shared/modal/default-modal/default-modal.component';

@Component({
  moduleId: module.id,
  selector: 'before-save-modal',
  templateUrl: 'before-save-modal.component.html',
  styleUrls: ['before-save-modal.component.scss'],
})
export class BeforeSaveModalComponent {
  updatePublished: boolean = false;
  @Input() itemsCount: Number;
  @Input() showUpdatePublished: boolean = false;
  @Output() confirm: EventEmitter<any> = new EventEmitter();
  @Output() cancel: EventEmitter<any> = new EventEmitter();
  @ViewChild('defaultModal', {static: false})
  private defaultModal: DefaultModalComponent | void;

  // public:
  public show() {
    if (this.defaultModal) {
      this.defaultModal.show();
    }
  }

  public hide() {
    if (this.defaultModal) {
      this.defaultModal.hide();
    }
  }

  // handlers:
  onCheckboxChange(event: any) {
    this.updatePublished = event.target.checked;
  }

  onCancelClick() {
    this.cancel.emit();
    if (this.defaultModal) {
      this.defaultModal.hide();
    }
  }

  onConfirmClick() {
    this.confirm.emit(this.updatePublished);
    if (this.defaultModal) {
      this.defaultModal.hide();
    }
  }
}
